import {
  SHOWN_TOOLTIP_ACTION,
  HIDDEN_TOOLTIP_ACTION,
  ENTER_TOOLTIP_ACTION,
  LEAVE_TOOLTIP_ACTION,
} from './TooltipManagerActions';

const INITIAL_STATE = {
  /* object[]
  [
    {
      text: string,
      opened: boolean,
      rect: elementReference,
      key: string,
    }
  ]
  */
  tooltips: [],
};

const getStateToShowTooltip = (state, tooltip) => {
  let newState = { ...state };
  const tooltipIndex = state.tooltips
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(tooltip.key);
  if (tooltipIndex > -1) {
    newState.tooltips[tooltipIndex] = tooltip;
  } else {
    newState.tooltips.push(tooltip);
  }
  return newState;
};

const getStateToHideTooltip = (state, key) => {
  let newState = { ...state };
  const tooltipIndex = state.tooltips
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(key);
  if (tooltipIndex > -1) {
    newState.tooltips[tooltipIndex] = {
      ...newState.tooltips[tooltipIndex],
      opened: false,
    };
  }
  return newState;
};

const getStateEnterChangedTooltip = (state, key, enter) => {
  let newState = { ...state };
  const tooltipIndex = state.tooltips
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(key);
  if (tooltipIndex > -1) {
    newState.tooltips[tooltipIndex] = {
      ...newState.tooltips[tooltipIndex],
      enter,
    };
  }
  return newState;
};

export default function TooltipManagerReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOWN_TOOLTIP_ACTION:
      return getStateToShowTooltip(state, action.payload);
    case HIDDEN_TOOLTIP_ACTION:
      return getStateToHideTooltip(state, action.payload);
    case ENTER_TOOLTIP_ACTION:
      return getStateEnterChangedTooltip(state, action.payload, true);
    case LEAVE_TOOLTIP_ACTION:
      return getStateEnterChangedTooltip(state, action.payload, false);
    default:
      return state;
  }
}
